import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Stethoscope, FolderOpen, ShieldCheck, WarningCircle } from "@phosphor-icons/react";

const TONE = { "Belum ada": "bg-slate-100 text-slate-500", Draft: "bg-amber-100 text-amber-700", Disahkan: "bg-emerald-100 text-emerald-700", "Ada Adendum": "bg-indigo-100 text-indigo-700" };

export default function EncountersList() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [ready, setReady] = useState({});
  useEffect(() => {
    document.title = "Kunjungan RME — HalloGBS";
    api.get("/clinical/encounters").then(async (r) => {
      const list = r.data.encounters;
      setRows(list);
      const ids = list.map((e) => e.encounter_id).filter(Boolean);
      if (ids.length) {
        try {
          const rr = await api.post("/satusehat/encounters/readiness", { ids });
          const map = {};
          rr.data.items.forEach((it) => { map[it.encounter_id] = it.ready; });
          setReady(map);
        } catch { /* readiness optional */ }
      }
    }).catch((e) => toast.error(apiError(e)));
  }, []);
  return (
    <div className="space-y-5" data-testid="encounters-list">
      <h1 className="flex items-center gap-2 font-heading text-2xl font-extrabold text-[#4C1D95]"><Stethoscope size={24} weight="duotone" className="text-[#DB2777]" /> Kunjungan / Rekam Medis</h1>
      <div className="overflow-x-auto rounded-2xl border border-pink-100 bg-white">
        <table className="w-full min-w-[680px] text-sm">
          <thead className="bg-[#FAF7FF] text-left text-xs text-slate-500"><tr><th className="p-3">Waktu</th><th className="p-3">Pasien</th><th className="p-3">Layanan</th><th className="p-3">Nakes</th><th className="p-3">Status</th><th className="p-3">SATUSEHAT</th><th className="p-3"></th></tr></thead>
          <tbody>
            {rows.map((e) => (
              <tr key={e.encounter_id} data-testid={`enc-row-${e.encounter_id}`} className="border-t border-pink-50">
                <td className="p-3 text-xs text-slate-500">{e.created_at ? new Date(e.created_at).toLocaleString("id-ID", { dateStyle: "short", timeStyle: "short" }) : "-"}</td>
                <td className="p-3 font-bold text-slate-800">{e.patient_nama}</td>
                <td className="p-3">{e.service || "-"}</td>
                <td className="p-3">{e.practitioner_nama || "-"}</td>
                <td className="p-3"><span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${TONE[e.clinical_status] || "bg-slate-100"}`}>{e.clinical_status}</span></td>
                <td className="p-3">
                  {ready[e.encounter_id] === undefined ? (
                    <span data-testid={`enc-readiness-unknown-${e.encounter_id}`} className="text-[11px] text-slate-300">—</span>
                  ) : ready[e.encounter_id] ? (
                    <span data-testid={`enc-readiness-ready-${e.encounter_id}`} className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-bold text-emerald-700"><ShieldCheck size={13} weight="fill" /> Siap</span>
                  ) : (
                    <button data-testid={`enc-readiness-notready-${e.encounter_id}`} onClick={() => nav(`/rekam-medis/${e.encounter_id}`)} title="Lihat checklist kesiapan" className="inline-flex items-center gap-1 rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-bold text-rose-700 transition-colors hover:bg-rose-200"><WarningCircle size={13} weight="fill" /> Belum Siap</button>
                  )}
                </td>
                <td className="p-3 text-right"><button data-testid={`enc-open-${e.encounter_id}`} onClick={() => nav(`/rekam-medis/${e.encounter_id}`)} className="flex items-center gap-1.5 rounded-lg bg-[#7C4DE0] px-3 py-1.5 text-xs font-bold text-white"><FolderOpen size={14} weight="fill" /> Buka Rekam Medis</button></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-slate-400">Belum ada kunjungan. Tandai reservasi "Sudah Datang" untuk membuat Encounter.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
